import * as PIXI from 'pixi.js';

export class Tooltip extends PIXI.Container {
  private background: PIXI.Graphics;
  private text: PIXI.Text;
  private maxWidth: number = 300;

  constructor() {
    super();
    
    this.background = new PIXI.Graphics();
    this.text = new PIXI.Text('', new PIXI.TextStyle({
      fontSize: 12,
      fill: 0xffffff,
      fontFamily: 'Arial, sans-serif',
      wordWrap: true,
      wordWrapWidth: this.maxWidth - 20,
      lineHeight: 16
    }));
    
    this.addChild(this.background);
    this.addChild(this.text);
    
    this.visible = false;
  }

  show(content: string, x: number, y: number): void {
    this.text.text = content;
    
    // Position text with padding
    this.text.x = 10;
    this.text.y = 10;
    
    // Calculate background size
    const textBounds = this.text.getBounds();
    const bgWidth = Math.min(textBounds.width + 20, this.maxWidth);
    const bgHeight = textBounds.height + 20;
    
    // Draw background with rounded corners and shadow effect
    this.background.clear();
    this.background.roundRect(0, 0, bgWidth, bgHeight, 6);
    this.background.fill(0x2d3436);
    this.background.stroke({ width: 1, color: 0x636e72 });
    
    // Position tooltip, avoiding screen edges
    this.x = x + 15; // Offset from cursor
    this.y = y - bgHeight - 10; // Above cursor
    
    // Adjust position if near screen edges
    const canvasWidth = 1920; // Approximate, could be made dynamic
    
    if (this.x + bgWidth > canvasWidth) {
      this.x = x - bgWidth - 15; // Move to left of cursor
    }
    
    if (this.y < 0) {
      this.y = y + 20; // Move below cursor
    }
    
    this.visible = true;
  }

  hide(): void {
    this.visible = false;
  }
}